module.exports = __webpack_public_path__ + "static/media/Screenshot1.1b008654.png";